module.exports = __webpack_public_path__ + "static/img/title.21440e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/ValuationProject/images/title.png
// module id = Yz7a
// module chunks = 5